import { toast } from "react-toastify";
import { api } from "../../../utils/api";

export const createParcelDescription = async (resetType, setLoading, setVisible, refetch, data) => {
  const notification = toast.loading("Adicionando..");
  try {
    setLoading(true);
    await api.post(`installment-desc`, data);
    resetType();
    await refetch();
    toast.update(notification, {
      render: "Nova Descrição Cadastrada com Sucesso!",
      type: "success",
      theme: "colored",
      autoClose: 5000,
      isLoading: false,
    });
  } catch (error) {
    const errorMessage = error.response
      ? error.response.data.errors.name
      : "Erro desconhecido ao excluir Descrição de Parcela.";
    toast.update(notification, {
      render: `Não Possível Cadastrar a Descrição de Parcela! Erro: ${errorMessage}`,
      type: "error",
      theme: "colored",
      autoClose: 3000,
      isLoading: false,
    });
  } finally {
    setLoading(false);
    setVisible(false);
  }
};
